(() => {
  const CONFIG_SELECTOR = '[data-trustpilot-merchant-listing-config]';
  const PRODUCT_TYPE = 'Product';

  const readConfig = () => {
    const element = document.querySelector(CONFIG_SELECTOR);
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  };

  const hasProductType = (value) => {
    const types = Array.isArray(value?.['@type']) ? value['@type'] : [value?.['@type']];
    return types.includes(PRODUCT_TYPE);
  };

  const belongsToCurrentProduct = (productSchema, config) => {
    if (productSchema.name === config.productName) return true;

    const offers = Array.isArray(productSchema.offers)
      ? productSchema.offers
      : [productSchema.offers];
    const urls = [productSchema.url, ...offers.map((offer) => offer?.url)].filter(Boolean);

    return urls.some((url) => String(url).includes(`/products/${config.productHandle}`));
  };

  const patchOffer = (offer, config) => {
    if (!offer || typeof offer !== 'object') return false;

    let changed = false;

    if (!offer.availability) {
      offer.availability = config.availability;
      changed = true;
    }

    if (!offer.itemCondition) {
      offer.itemCondition = 'https://schema.org/NewCondition';
      changed = true;
    }

    if (!offer.shippingDetails) {
      offer.shippingDetails = {
        '@type': 'OfferShippingDetails',
        hasShippingService: {
          '@id': config.shippingPolicyId,
        },
      };
      changed = true;
    }

    if (!offer.hasMerchantReturnPolicy) {
      offer.hasMerchantReturnPolicy = {
        '@id': config.returnPolicyId,
      };
      changed = true;
    }

    return changed;
  };

  const patchProductSchema = (productSchema, config) => {
    if (
      !hasProductType(productSchema) ||
      !productSchema.aggregateRating ||
      !belongsToCurrentProduct(productSchema, config)
    ) {
      return false;
    }

    const offers = Array.isArray(productSchema.offers)
      ? productSchema.offers
      : [productSchema.offers];

    let changed = false;
    offers.forEach((offer) => {
      changed = patchOffer(offer, config) || changed;
    });

    return changed;
  };

  const patchValue = (value, config) => {
    if (Array.isArray(value)) {
      let changed = false;
      value.forEach((item) => {
        changed = patchValue(item, config) || changed;
      });
      return changed;
    }

    if (!value || typeof value !== 'object') return false;

    let changed = patchProductSchema(value, config);

    if (Array.isArray(value['@graph'])) {
      changed = patchValue(value['@graph'], config) || changed;
    }

    return changed;
  };

  const patchStructuredData = () => {
    const config = readConfig();
    if (!config) return;

    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      try {
        const value = JSON.parse(script.textContent);
        if (!patchValue(value, config)) return;

        script.textContent = JSON.stringify(value);
        script.dataset.trustpilotMerchantPatched = 'true';
      } catch (error) {
        // Ignore structured data owned by other integrations.
      }
    });
  };

  const start = () => {
    patchStructuredData();

    const observer = new MutationObserver(patchStructuredData);
    observer.observe(document.head || document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), 20000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', patchStructuredData);
})();
